import { ref, watch, onBeforeUnmount, type WatchStopHandle } from 'vue'
import useAnimationFrame from '@/composables/base/useAnimationFrame'

const globalClockTick = ref(0)
let animationFrameControl: ReturnType<typeof useAnimationFrame> | null = null
let subscriberCount = 0

function startGlobalClock() {
    if (animationFrameControl !== null) {
        return
    }

    animationFrameControl = useAnimationFrame(
        () => {
            globalClockTick.value++
        },
        { 
            fpsLimit: 1,
            immediate: true 
        }
    )
}

function stopGlobalClock() {
    if (animationFrameControl) {
        animationFrameControl.pause()
        animationFrameControl = null
    }
}

export function useSynchronizedClock(callback: () => void) {
    subscriberCount++
    
    if (subscriberCount === 1) {
        startGlobalClock()
    }

    const stopWatcher: WatchStopHandle = watch(
        globalClockTick,
        () => {
            callback()
        },
        { immediate: true }
    )

    onBeforeUnmount(() => {
        stopWatcher()
        subscriberCount--
        
        if (subscriberCount <= 0) {
            subscriberCount = 0
            stopGlobalClock()
        }
    })

    return {
        clockTick: globalClockTick
    }
}
